export enum BankEnum {
    DUMMY = 0, // 0000
    BCV = 1, // 0001
    VENEZUELA = 2, // 0102
    VENEZOLANO_CREDITO = 3, // 0104
    MERCANTIL = 4, // 0105
    PROVINCIAL = 5, // 0108
    BANCARIBE = 6, // 0114
    EXTERIOR = 7, // 0151
    CARONI = 8, // 0146
    BANESCO = 9, // 0134
    SOFITASA = 10, // 0115
    PLAZA = 11, // 0128
    BANGENTE = 12, // 0138
    FONDO_COMUN = 13, // 0137
    BANCO_100PORCIENTO = 14, // 0156
    DELSUR = 15, // 0157
    DEL_TESORO = 16, // 0166
    AGRICOLA = 17, // 0175
    BANCRECER = 18, // 0172
    R4 = 19, // 0168
    ACTIVO = 20, // 0174
    BANCAMIGA = 21, // 0177
    BID = 22, // 0173
    BANPLUS = 23, // 0169
    BICENTENARIO = 24, // 0171
    BANFAN = 25, // 0163
    BNC = 26, // 0191
    MERCHANT = 27, // 9999
    BANESCO_PANAMA = 28, // 5000
    FACEBANK = 29, // 5001
    ARCA = 30, // 5002
    MERCANTIL_PANAMA = 31,
    CHASE = 32,
}

type Bank = {
    BankID: number;
    BankCode: string;
    BankName: string;
};

export const banks: Bank[] = [
  { BankID: 0, BankCode: "0000", BankName: "Dummy" },
  { BankID: 1, BankCode: "0001", BankName: "BCV" },
  { BankID: 2, BankCode: "0102", BankName: "Banco De Venezuela" },
  { BankID: 3, BankCode: "0104", BankName: "Banco Venezolano De Crédito" },
  { BankID: 4, BankCode: "0105", BankName: "Banco Mercantil" },
  { BankID: 5, BankCode: "0108", BankName: "Banco Provincial" },
  { BankID: 6, BankCode: "0114", BankName: "Bancaribe" },
  { BankID: 7, BankCode: "0115", BankName: "Banco Sofitasa" },
  { BankID: 8, BankCode: "0128", BankName: "Banco Plaza" },
  { BankID: 9, BankCode: "0134", BankName: "Banesco" },
  { BankID: 10, BankCode: "0137", BankName: "Banco Fondo Común" },
  { BankID: 11, BankCode: "0138", BankName: "Bangente" },
  { BankID: 12, BankCode: "0146", BankName: "Banco Caroní" },
  { BankID: 13, BankCode: "0151", BankName: "Banco Exterior" },
  { BankID: 14, BankCode: "0156", BankName: "100% Banco" },
  { BankID: 15, BankCode: "0157", BankName: "Delsur" },
  { BankID: 16, BankCode: "0163", BankName: "Banfan" },
  { BankID: 17, BankCode: "0166", BankName: "Banco Del Tesoro" },
  { BankID: 18, BankCode: "0168", BankName: "Mi Banco (R4)" },
  { BankID: 19, BankCode: "0169", BankName: "Banplus" },
  { BankID: 20, BankCode: "0171", BankName: "Bicentenario" },
  { BankID: 21, BankCode: "0172", BankName: "Bancrecer" },
  { BankID: 22, BankCode: "0173", BankName: "BID" },
  { BankID: 23, BankCode: "0174", BankName: "Banco Activo" },
  { BankID: 24, BankCode: "0175", BankName: "Banco Agrícola" },
  { BankID: 25, BankCode: "0177", BankName: "Bancamiga" },
  { BankID: 26, BankCode: "0191", BankName: "Banco Nacional De Crédito" },
  { BankID: 27, BankCode: "9999", BankName: "Merchant" },
  { BankID: 28, BankCode: "5000", BankName: "Banesco Panamá" },
  { BankID: 29, BankCode: "5001", BankName: "FaceBank" },
  { BankID: 30, BankCode: "5002", BankName: "Arca Bank" },
  { BankID: 31, BankCode: "5003", BankName: "Mercantil Panamá" },
  { BankID: 32, BankCode: "5004", BankName: "Chase Bank" },
];